import $ from 'jquery'
window.jQuery = window.$ = $;

import responsify from 'responsify-vanilla-js';

require("waypoints/lib/noframework.waypoints.min.js");
let isInAdmin = $('body').hasClass('wp-admin')

/*----------  Escape to Login  ----------*/

function goToLogin(){
    var rootUrl = window.location.origin;
    setTimeout(function(){
        window.location.href = rootUrl + "/hirc-login";
    },100);
}

$(document).keydown(function(e) {
    let modalOpen = false
    
    if($('body').hasClass('modal-open') || $('body').hasClass('modal-is-open')) { modalOpen = true }


    if ( e.keyCode === 27 && !modalOpen && !isInAdmin ){
        goToLogin();
    }
});




var quoteSliderElem = document.querySelector('.quote-slider__carousel');

if(quoteSliderElem) {
    var quoteSlider = new Flickity('.quote-slider__carousel', {autoPlay: 5000, prevNextButtons: false, wrapAround: true})

    function appendImagesToDots(cells, dots) {
        const DEFAULT_IMAGE = '/wp-content/themes/hirc-custom/public/img/generic-person.jpg';

        if (cells.length !== dots.length) {
            console.error('The number of items in "cells" and "dots" must be the same.');
            return;
        }

        for (let i = 0; i < cells.length; i++) {
            const cell = cells[i];
            const dot = dots[i];
            const imageSrc = cell.getAttribute('data-source-image') || DEFAULT_IMAGE;

            const image = new Image();
            image.src = imageSrc;
            dot.appendChild(image);
        }
    }

//     var cells = quoteSlider.find('.carousel-cell');
    const cells = quoteSlider.$element[0].getElementsByClassName('quote-slider__carousel__cell');
    const dots = quoteSlider.$element[0].getElementsByClassName('flickity-page-dot');
    
    appendImagesToDots(cells, dots);
}

/* Tabs for Standards */

let adminBar, hasAdminBar, adminBarHeight;

$(document).ready(function () {
    let hashString = getHashStringFromUrl()
    adminBar = $('#wpadminbar')
    hasAdminBar = adminBar.length > 0
    adminBarHeight = 32

    if(hashString !== null) {
        setTimeout(() => {
            window.scrollTo(0, 0);
            makeTabActiveAndScroll(hashString)
        }, 100);
    }

    $(".tabbed-section__tab a").on("click", function (e) {
        e.preventDefault();
        // console.log('clicked');
        let hash = $(this).attr("href")

        // Remove the "active" class from all tab links and tabs
        $(".tabbed-section__tab-tray .tabbed-section__tab, .tabbed-section__content__tab").removeClass("active");

        // Add the "active" class to the clicked tab link and its corresponding tab
        $(this).parent(".tabbed-section__tab").addClass("active");
        $(hash).addClass("active");
        // Append the hash string to the URL without reloading the page
        if (history.replaceState) {
            history.replaceState(null, null, hash);
        } else {
            location.hash = hash;
        }
    });
    $('.faq_accordion dt').on('click', function (e) {
        let dt = $(this)
        let dd = $(this).next()
        if(dt.hasClass('active')) {
            dt.removeClass('active')
            dd.removeClass('active')
            dd.css('max-height', '')
        } else {
            dt.addClass('active')
            dd.addClass('active')
            let measureStick = dd.find('.dd_inside')
            let maxHeight = measureStick.outerHeight()
            dd.css('max-height', maxHeight);
        }
    })
});

function getHashStringFromUrl() {
    const hash = window.location.hash;
    if (hash && document.getElementById(hash.substring(1))) {
        return hash.substring(1);
    } else {
        return null;
    }
}

function makeTabActiveAndScroll(hashString) {
    let tab = $('.tabbed-section__tab a[href="#' + hashString + '"]').parent('.tabbed-section__tab')
    let tabContent = $('.tabbed-section__content #' + hashString)
    // console.log({'tabContent' : tabContent});
    $(".tabbed-section__tab-tray .tabbed-section__tab, .tabbed-section__content__tab").removeClass("active");
    tab.addClass('active')
    tabContent.addClass('active')
    setTimeout(() => {
        const offset = -60;
        const elementPosition = tab[0].getBoundingClientRect().top + window.scrollY;
        const offsetPosition = hasAdminBar ? elementPosition + offset - adminBarHeight : elementPosition + offset;
        // console.log({'offsetPosition' : offsetPosition});
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }, 500);
}


/**----------------------
 *    LEADER GALLERY
 *------------------------**/
const leaderGalleryNav = document.querySelector('.leader-gallery__scroll-nav ul')
if(leaderGalleryNav) {
    const header = document.getElementById('header');
    const headerHeight = header.offsetHeight;
    const additionalOffset = 16
    
    // Smooth scroll on click

    document.querySelectorAll('.leader-gallery__scroll-nav ul li a').forEach(link => {
        const target = document.querySelector(link.getAttribute('href'));
        
        // Handle click
        link.addEventListener('click', function(event) {
            event.preventDefault();
            target.style.scrollMarginTop = `${headerHeight + additionalOffset}px`; 
            target.scrollIntoView({
                behavior: 'smooth'
            });
        });

        var waypoint = new Waypoint({
            element:target,
            handler: function(direction) {
                const li = link.parentNode.closest('li')
                const ul = li.parentNode
                ul.querySelectorAll('li').forEach(sibling => sibling.classList.remove('active'));
                li.classList.add('active')
            },
            offset: '75%'
        })
        
        
    });
    
    /*----------  Make Leader Gallery Navigation Sticky  ----------*/

    const wrapInDiv = (elem, wrapperClass = 'sticky-wrapper') => {
        const wrapper = document.createElement('div')
        wrapper.classList.add(wrapperClass)
        elem.parentNode.insertBefore(wrapper, elem)
        wrapper.appendChild(elem)
    }
    
    // Makes nav sticky
    
    const wrapperClass = 'sticky-wrapper'
    wrapInDiv(leaderGalleryNav, wrapperClass)
    // if(!isInAdmin) {
    // }
    let stickyWrapperElem = document.getElementsByClassName(wrapperClass)[0]

    var galleryWaypoint = new Waypoint({
        element: leaderGalleryNav,
        handler(direction){
            let stickWrap = this.element
            if(direction === 'down') {
                // console.log({'stickWrap' : stickWrap});
                stickyWrapperElem.style.height = stickWrap.getBoundingClientRect().height + 'px'
                stickyWrapperElem.style.width = stickWrap.getBoundingClientRect().width + 'px'
                stickyWrapperElem.classList.add('sticky-wrapper--stuck')
            } else {
                stickyWrapperElem.style = ''
                stickyWrapperElem.classList.remove('sticky-wrapper--stuck')
                stickyWrapperElem.querySelectorAll('li').forEach((item, index)=>{
                    if(index === 0) {
                        item.classList.add('active')
                    } else {
                        item.classList.remove('active')
                    }
                })
            }
        },
        // offset: hasAdminBar ? adminBar.getBoundingClientRect().height : 0,
        offset: 64
    })    
}

/**------------------------
 *    RESPONSIFY IMAGES
 *--------------------------**/

responsify('.js-focal-point-image');

// Blog
// -----

function setResponsifyDataAttributes(elem, focalArea){
    elem.setAttribute('data-focus-top', focalArea.top)
    elem.setAttribute('data-focus-left', focalArea.left)
    elem.setAttribute('data-focus-right', focalArea.right)
    elem.setAttribute('data-focus-bottom', focalArea.bottom)
}

$(document).ready(function() {
    let blogMainImgContainer = document.querySelector('.blog-hero__lg');
    // let blogMainImg = blogMainImgContainer.querySelector('img');
    if (blogMainImgContainer instanceof HTMLElement) {
        var mainImg = new Image();
        var mainImgSrc = blogMainImgContainer.getAttribute('data-blog-main-img-src')
        var mainImgFocalArea = {
            top: blogMainImgContainer.getAttribute('data-fp-top'),
            left: blogMainImgContainer.getAttribute('data-fp-left'),
            right: blogMainImgContainer.getAttribute('data-fp-right'),
            bottom: blogMainImgContainer.getAttribute('data-fp-bottom')
        }
        console.log({'mainImgFocalArea' : mainImgFocalArea});
        var blogMainScaler = document.querySelector('.blog-hero__scaler')

        mainImg.onload = function() {
            // Once the image is loaded, insert it into the div
            var div = blogMainImgContainer;
            div.appendChild(mainImg);

            // Change the div's style
            div.style.opacity = '1';

            responsify([mainImg]);

            blogMainScaler.classList.add('zoom-back')
        };

        mainImg.src = mainImgSrc;
        setResponsifyDataAttributes(mainImg, mainImgFocalArea );
    }
});